export function getWindowHeight() {
  return window.innerHeight;
}
